import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Search, Bell, ChevronDown, CircleDot, Menu, User, Settings, LogOut, X } from 'lucide-react';
import { Input } from '../ui/Input';
import { Avatar, AvatarFallback } from '../ui/Avatar';
import { cn } from '../../utils/cn';
const notifications = [{
  id: 1,
  title: 'Новый заказ № 10482',
  text: 'проспект Махтумкули, 22 — ожидает назначения',
  time: '2 мин назад',
  unread: true
}, {
  id: 2,
  title: 'Водитель вышел на линию',
  text: 'Мердан Ходжаев, площадь Гарашсызлык',
  time: '9 мин назад',
  unread: true
}, {
  id: 3,
  title: 'Поездка завершена',
  text: 'Айна Реджепова · 21 TMT',
  time: '24 мин назад',
  unread: false
}];
export function Header({
  onMenuClick
}: {
  onMenuClick: () => void;
}) {
  const navigate = useNavigate();
  const [bellOpen, setBellOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [query, setQuery] = useState('');
  const unread = notifications.filter(n => n.unread).length;
  return <header className="sticky top-0 z-30 shrink-0 border-b border-border bg-card/95 backdrop-blur" data-id="element-40" data-mp="bu88nu5wg8vn">
      <div className="flex h-16 items-center gap-2 px-3 sm:px-4 md:px-6" data-id="element-41" data-mp="gkyipkp9szwo">
        <button type="button" onClick={onMenuClick} className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-foreground transition-colors hover:bg-accent md:hidden" aria-label="Открыть меню" data-id="element-42" data-mp="lkl3qgbcbkg1">
          <Menu className="h-5 w-5" data-id="element-43" data-mp="3p1thanz1by4y" />
        </button>

        {/* Поиск на планшетах и компьютерах */}
        <div className="relative hidden w-full max-w-md sm:block" data-id="element-44" data-mp="3tz37w6y5ufud">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" aria-hidden="true" data-id="element-45" data-mp="1xn419xskzsc" />
          <Input value={query} onChange={e => setQuery(e.target.value)} placeholder="Поиск заказа, водителя или адреса…" aria-label="Поиск" className="h-9 pl-9" data-id="element-46" data-mp="19c8cbi4qi8ti" />
        </div>

        <div className="ml-auto flex items-center gap-1 sm:gap-2" data-id="element-47" data-mp="35e3d2tnbmj6x">
          <button type="button" onClick={() => setSearchOpen(v => !v)} className="flex h-10 w-10 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-accent hover:text-foreground sm:hidden" aria-label={searchOpen ? 'Закрыть поиск' : 'Открыть поиск'} aria-expanded={searchOpen} data-id="element-48" data-mp="3jd30jxz3ks1i">
            {searchOpen ? <X className="h-[18px] w-[18px]" data-id="element-49" data-mp="30e79gvijctrw" /> : <Search className="h-[18px] w-[18px]" data-id="element-50" data-mp="30f8vfv13b0oe" />}
          </button>

          <span className="hidden items-center gap-1.5 rounded-full border border-emerald-500/30 bg-emerald-500/10 px-2.5 py-1 text-xs font-medium text-emerald-700 lg:inline-flex" data-id="element-51" data-mp="2vnqsx2jf4s1b">
            <CircleDot className="h-3 w-3" aria-hidden="true" data-id="element-52" data-mp="22yte59ef1ddb" />
            Система в сети
          </span>

          {/* Уведомления */}
          <div className="relative" data-id="element-53" data-mp="ifpx75bxw85m">
            <button type="button" onClick={() => {
            setBellOpen(v => !v);
            setProfileOpen(false);
          }} className="relative flex h-10 w-10 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-accent hover:text-foreground" aria-label={`Уведомления (${unread} новых)`} aria-expanded={bellOpen} data-id="element-54" data-mp="ifhg118sagom">
              <Bell className="h-[18px] w-[18px]" data-id="element-55" data-mp="166my7n275l23" />
              {unread > 0 && <span className="absolute right-1.5 top-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-semibold text-white" data-id="element-56" data-mp="s6u89tyhv8v6">
                  {unread}
                </span>}
            </button>

            {bellOpen && <>
                <div className="fixed inset-0 z-40" onClick={() => setBellOpen(false)} aria-hidden="true" data-id="element-57" data-mp="3hwfjpl5kfjte" />
                <div className="absolute right-0 z-50 mt-2 w-[min(20rem,calc(100vw-1.5rem))] overflow-hidden rounded-xl border border-border bg-popover shadow-lg" data-id="element-58" data-mp="10evl0yx8cq8">
                  <div className="flex items-center justify-between border-b border-border px-4 py-2.5" data-id="element-59" data-mp="3od8wszd10iw9">
                    <p className="text-sm font-semibold text-popover-foreground" data-id="element-60" data-mp="3je4la22mq92r">Уведомления</p>
                    <button type="button" className="text-xs font-medium text-primary hover:underline" data-id="element-61" data-mp="jz0xgi29i7v7">
                      Прочитать все
                    </button>
                  </div>
                  <ul className="max-h-80 overflow-y-auto" data-id="element-62" data-mp="fvl1lny0objk">
                    {notifications.map(n => <li key={n.id} data-id="element-63" data-mp="5zi44ve4112y">
                        <button type="button" className="flex w-full gap-3 px-4 py-3 text-left transition-colors hover:bg-accent" data-id="element-64" data-mp="5ygftp832i3a">
                          <span className={cn('mt-1.5 h-2 w-2 shrink-0 rounded-full', n.unread ? 'bg-primary' : 'bg-border')} data-id="element-65" data-mp="2vmh5af6woif9" />
                          <span className="min-w-0" data-id="element-66" data-mp="2glse6jicns9k">
                            <span className="block truncate text-sm font-medium text-foreground" data-id="element-67" data-mp="2gn3fmcobonxi">{n.title}</span>
                            <span className="block truncate text-xs text-muted-foreground" data-id="element-68" data-mp="2liiv191zarw1">{n.text}</span>
                            <span className="mt-0.5 block text-[11px] text-muted-foreground" data-id="element-69" data-mp="2qhn5s44jwxoh">{n.time}</span>
                          </span>
                        </button>
                      </li>)}
                  </ul>
                </div>
              </>}
          </div>

          {/* Профиль оператора */}
          <div className="relative" data-id="element-70" data-mp="399y2fg8m3ze5">
            <button type="button" onClick={() => {
            setProfileOpen(v => !v);
            setBellOpen(false);
          }} className="flex items-center gap-2 rounded-lg py-1 pl-1 pr-1 transition-colors hover:bg-accent sm:pr-2" aria-label="Меню профиля" aria-expanded={profileOpen} aria-haspopup="menu" data-id="element-71" data-mp="39azbjf62ibt8">
              <Avatar className="h-8 w-8" data-id="element-72" data-mp="1bweqsjqz5hob">
                <AvatarFallback className="bg-primary/10 text-xs font-semibold text-primary" data-id="element-73" data-mp="16wk2mnyl366y">ММ</AvatarFallback>
              </Avatar>
              <span className="hidden text-left leading-tight sm:block" data-id="element-74" data-mp="1lu2pfkrpb9br">
                <span className="block text-sm font-medium text-foreground" data-id="element-75" data-mp="1gsvgvjhqi641">Мырат Мырадов</span>
                <span className="block text-[11px] text-muted-foreground" data-id="element-76" data-mp="1usee3h90bx1k">Старший оператор</span>
              </span>
              <ChevronDown className={cn('hidden h-4 w-4 text-muted-foreground transition-transform sm:block', profileOpen && 'rotate-180')} aria-hidden="true" data-id="element-77" data-mp="1pttki0o9gbm3" />
            </button>

            {profileOpen && <>
                <div className="fixed inset-0 z-40" onClick={() => setProfileOpen(false)} aria-hidden="true" data-id="element-78" data-mp="2dkyyeaan4ttr" />
                <div role="menu" aria-label="Меню профиля" className="absolute right-0 z-50 mt-2 w-[min(15rem,calc(100vw-1.5rem))] overflow-hidden rounded-xl border border-border bg-popover shadow-lg" data-id="element-79" data-mp="29jwzxvojslsu">
                  <div className="border-b border-border px-4 py-3" data-id="element-80" data-mp="2j6r4nivwlp8w">
                    <p className="text-sm font-semibold text-popover-foreground" data-id="element-81" data-mp="2o511rz16uzx5">Мырат Мырадов</p>
                    <p className="truncate text-xs text-muted-foreground" data-id="element-82" data-mp="29g4z6hhwif3x">myrat.myradov@ashgabat-taksi.tm</p>
                  </div>
                  <div className="p-1" data-id="element-83" data-mp="2e74whnuxmz6y">
                    <button type="button" role="menuitem" onClick={() => {
                  setProfileOpen(false);
                  toast.info('Профиль оператора', {
                    description: 'Мырат Мырадов · Старший оператор'
                  });
                }} className="flex w-full items-center gap-2.5 rounded-lg px-3 py-2 text-sm text-foreground transition-colors hover:bg-accent" data-id="element-84" data-mp="2e8y1yztt7ddd">
                      <User className="h-4 w-4 text-muted-foreground" aria-hidden="true" data-id="element-85" data-mp="2axlq7d6beb59" />
                      Мой профиль
                    </button>
                    <button type="button" role="menuitem" onClick={() => {
                  setProfileOpen(false);
                  navigate('/settings');
                }} className="flex w-full items-center gap-2.5 rounded-lg px-3 py-2 text-sm text-foreground transition-colors hover:bg-accent" data-id="element-86" data-mp="21x70m1mbi9vy">
                      <Settings className="h-4 w-4 text-muted-foreground" aria-hidden="true" data-id="element-87" data-mp="1iaitmql78ahn" />
                      Настройки
                    </button>
                  </div>
                  <div className="border-t border-border p-1" data-id="element-88" data-mp="199avc8ion9nk">
                    <button type="button" role="menuitem" onClick={() => {
                  setProfileOpen(false);
                  toast.success('Вы вышли из системы', {
                    description: 'Сессия оператора завершена.'
                  });
                }} className="flex w-full items-center gap-2.5 rounded-lg px-3 py-2 text-sm font-medium text-red-600 transition-colors hover:bg-red-500/10" data-id="element-89" data-mp="19avqo0ctmwmh">
                      <LogOut className="h-4 w-4" aria-hidden="true" data-id="element-90" data-mp="2x6sh53i8w1aj" />
                      Выйти
                    </button>
                  </div>
                </div>
              </>}
          </div>
        </div>
      </div>

      {/* Поиск на телефонах */}
      {searchOpen && <div className="border-t border-border px-3 py-2 sm:hidden" data-id="element-91" data-mp="3ay705ac5k2hl">
          <div className="relative" data-id="element-92" data-mp="3azi3xa5lla8p">
            <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" aria-hidden="true" data-id="element-93" data-mp="2egkiaxlkvx05" />
            <Input value={query} onChange={e => setQuery(e.target.value)} placeholder="Поиск заказа или водителя…" aria-label="Поиск" autoFocus className="h-9 pl-9" data-id="element-94" data-mp="2igl6vb2e5okx" />
          </div>
        </div>}
    </header>;
}